import React from "react";
import PropTypes from "prop-types";
import SectionContainer from "../../../components/sectionContainer/sectionContainer";
import ProjectedBar from "../../../components/projectedBar/projectedBar";
import CreateFloatingGroup from "../../../components/createFloatingGroup/createFloatingGroup";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlusCircle } from "@fortawesome/free-solid-svg-icons";

export class GoalsToWatchModule extends React.Component {
  constructor(props) {
    super(props);
    this.defaultCheckedItems = this.props.defaultCheckedItems || {};
    this.state = {
      maxChecked: false,
      selectedList: this.props.defaultCheckedItems,
      renderForm: true
    };
  }
  removeGoal(id) {
    let selectedGoals = [...this.state.selectedList];
    let goalsToSend = [];

    selectedGoals.map(item => {
      if (parseInt(item.id) === parseInt(id) || parseInt(item) === parseInt(id)) {
        return;
      } else {
        goalsToSend.push(parseInt(item.id) || parseInt(item));
      }
    });

    this.setState({
      selectedList: goalsToSend,
      maxChecked: goalsToSend.length === 3
    });

    this.props.onSubmit({ data: goalsToSend });
  }
  getDefaultChecked() {
    let goals = {};
    this.props.defaultCheckedItems.map(goal => {
      goals[goal.id] = true;
    });
    return goals;
  }
  getMaxChecked() {
    let selected = Object.entries(this.props.defaultCheckedItems);
    if (selected.length === 3) {
      this.setState({
        maxChecked: true
      });
    } else {
      this.setState({
        maxChecked: false
      });
    }
  }
  setRenderForm() {
    this.setState({
      renderForm: false
    });
    setTimeout(() => {
      this.setState({
        renderForm: true
      });
    }, 1);
  }
  onSubmit() {
    this.setRenderForm();
    this.props.onSubmit({ data: this.state.selectedList });
  }
  UNSAFE_componentWillMount() {
    this.getMaxChecked();
  }
  render() {
    return (
      <SectionContainer title={this.props.title}>
        {this.props.data.map((item, key) => (
          <ProjectedBar
            metricTitle={item.metricTitle}
            locationName={!this.props.currentUser.singleLocation ? item.locationName : ""}
            value={item.value / 100}
            projectedValue={item.projectedValue / 100}
            currentVal={item.currentVal}
            currentValPacing={item.currentValPacing}
            currencySymbol={item.currencySymbol}
            onMinusClick={() => this.removeGoal(item.id)}
            hideMinus={this.props.data.length === 1}
            key={key}
            isStacked
            defaultTooltip
          />
        ))}
        <div className="current-key" style={{ top: this.props.currentUser.singleLocation ? 300 : 325 }}>
          Current Value
        </div>
        <div className="projected-key" style={{ top: this.props.currentUser.singleLocation ? 325 : 350 }}>
          Projected Forecast
        </div>

        {this.state.renderForm ? (
          <CreateFloatingGroup
            title="Select Goals (3 Max)"
            module={this.props.moduleName}
            selectHeight={350}
            modalHeight={380}
            modalWidth={355}
            modalTop={125}
            modalPositionRight
            modalRightOffset={9}
            overrideButton
            hasPreLabel={!this.props.singleLocation}
            buttonContent={
              <div className="add-goal-wrapper">
                <p className="add-goal-button">ADD A GOAL</p>
                <FontAwesomeIcon icon={faPlusCircle} style={{ color: "#8ac934" }} />
              </div>
            }
            defaultCheckedItems={this.getDefaultChecked()}
            checkList={this.props.checkList}
            onSubmit={() => this.onSubmit()}
            maxChecked={this.state.maxChecked}
            itemWasChecked={goals => {
              let selectedList = [];
              let values = Object.entries(goals);
              values.map(item => {
                if (item[1] === true) {
                  selectedList.push(item[0]);
                  this.setState({
                    selectedList: selectedList
                  });
                }
              });
              if (selectedList.length === 3) {
                this.setState({
                  maxChecked: true
                });
              } else {
                this.setState({
                  maxChecked: false
                });
              }
            }}
          />
        ) : null}
      </SectionContainer>
    );
  }
}

export default GoalsToWatchModule;

GoalsToWatchModule.propTypes = {
  title: PropTypes.string,
  data: PropTypes.array,
  checkList: PropTypes.array,
  defaultCheckedItems: PropTypes.array,
  onSubmit: PropTypes.func.isRequired,
  moduleName: PropTypes.string.isRequired, // Name of element to attach list modal to
  currentUser: PropTypes.object,
  singleLocation: PropTypes.bool
};
